import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar';
import Header from './header';

const LayoutDashboard = ({ children }) => {
    const [loader, setLoader] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const handleToggleSidebar = (openOnly=false) => {
        if(openOnly){
            setShowSidebar(false);
        }else{
            setShowSidebar(prev => !prev);
        }
    };
    return (
        <div className={`${showSidebar ? 'onmobile' : ''}`} style={{ position: 'relative', minHeight: '100vh' }}>
            {loader && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)', // semi-transparent white
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="spinner-border spinner-border-lg" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            
            {/* Regular content */}
            <Header handleToggleSidebar={handleToggleSidebar}/>
            <Sidebar handleToggleSidebar={handleToggleSidebar} showSidebar={showSidebar} loader={loader} setLoader={setLoader} />
            <Outlet />
            {children}
        </div>
    );
}

export default LayoutDashboard;